export enum RefundProcessStep {
    CHECK_REFUND_STATUS,
    ELIGIBILITY,
    INELIGIBLE,
    ITINERARY_CANCEL_CHECK,
    UPDATE_SABRE_PENDING,
    SUBMIT_TO_RAC,
    NOTIFY_CUSTOMER_REFUND_PENDING
}
